import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { InvestmentCreateFormFields } from "web_myplann/Portfolio/Forms/InvestmentForm/InvestmentCreateFormFields";
import { useCreateInvestmentForm } from "web_myplann/Portfolio/Forms/InvestmentForm/useCreateInvestmentForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

export const CreateInvestmentForm = () => {
	const { t } = useResource();
	const { form, onSubmit, isPending } = useCreateInvestmentForm();

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.AddShared.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
		>
			<InvestmentCreateFormFields control={form.control} />
		</PortfolioFormShell>
	);
};
